<template>
  <Modal
    :width="'879px'"
    :visible="props.visible"
    @update:visible="(v) => (v ? emits('update:visible', v) : close())"
    :footer="null"
    :title="null"
    :maskClosable="false"
    :wrapClassName="$style.Modal"
    :zIndex="props.zIndex"
    centered
  >
    <div :class="$style.Container">
      <Introduction
        :skuType="activeTab"
        :seat="selectPeople"
        :isPersonal="isPersonal"
        :amount="activeSku?.amount"
        :expiresIn="activeSku?.expiresIn"
        :seatNum="selectPeople ? activeSku?.seat : ''"
        :price="activeSku?.displayPrice"
        :loading="skuLoading"
      />
      <div :class="$style.Content">
        <Header
          :avatarUrl="orgInfo.logo"
          :title="orgInfo.fullName"
          :lingdouNum="lingdouInfo?.total"
          :isPersonal="isPersonal"
          :expireTime="lingdouInfo?.memberShip?.expireTime"
          :isVip="isVip"
          v-if="orgInfo"
        />
        <SkeletonButton :class="$style.SkeletonButton" style="width: 100px; height: 72px" v-else />

        <div style="margin-top: 24px" :class="$style.SkuError" v-if="skuError"
          ><Button type="primary" @click="init">出错啦，点击重新加载</Button></div
        >

        <template v-else-if="skuLoading">
          <SkeletonButton :class="$style.SkeletonButton" style="margin-top: 24px; height: 46px" />
          <div style="margin-top: 24px" :class="$style.SkuLoading">
            <SkeletonButton v-for="item in 2" :key="item" :class="$style.SkeletonButton" /> </div
        ></template>

        <template v-else>
          <Tab
            v-if="!props.onlyShowActiveSku && !props.onlyLingdou"
            style="margin-top: 16px"
            :active="activeTab"
            @update:active="handleUpdateTab"
            :tabs="tabsList"
          />

          <div
            v-if="!isPersonal && activeTab === SKU_TYPE.VIP"
            :class="$style.PayBlock"
            style="margin-top: 24px; padding: 0; background-color: unset"
          >
            <SelectPeople
              :value="selectPeople"
              :disabled="props.onlyShowActiveSku"
              @update:value="handleUpdateSelectPeople"
              :showTip="selectPeople && isVip"
              :expireTime="lingdouInfo?.memberShip?.expireTime"
          /></div>

          <SwiperList
            v-if="skusList?.length"
            style="margin-top: 24px"
            :list="skusList"
            :activeIndex="skusList.findIndex((v) => v.skuID === activeSkuId)"
            :gap="16"
            listKey="id"
            :justifyContent="skusList.length === 1 ? 'center' : 'left'"
          >
            <template #item="{ item, index }">
              <Sku
                :recommendTitle="
                  index === 0
                    ? isPersonal
                      ? item.type === SKU_TYPE.PURCHASE
                        ? ''
                        : '最划算'
                      : '团队优选'
                    : ''
                "
                :description="item.description"
                :des="item.des"
                :amount="item.amount"
                :originPrice="item.originPrice"
                :price="item.displayPrice"
                :expiresIn="item.expiresIn"
                :type="item.type"
                :active="item.skuId === activeSkuId"
                :first="item.first"
                @click="handleActiveSku(item.skuId)"
              />
            </template>
          </SwiperList>
        </template>

        <!-- 购买超过20人 -->
        <Customer
          style="margin-top: 16px"
          v-if="!skuLoading && activeTab === SKU_TYPE.VIP && !skusList.length"
        />

        <div :class="$style.PayBlock" style="margin-top: 24px" v-else>
          <!-- 购买的席位小于当前席位 -->
          <div
            :class="$style.MemberTip"
            v-if="!skuLoading && activeTab === SKU_TYPE.VIP && orgInfo?.memberCount > +selectPeople"
          >
            <template v-if="isAdmin">
              您当前团队内人数超出该套餐团队人数上限，请管理团队人数或更换其他套餐。
              <div
                ><Button
                  type="primary"
                  @click="
                    () => {
                      props.onGoMemberPage?.();
                      close();
                    }
                  "
                  >成员管理</Button
                ></div
              ></template
            >
            <template v-else>
              您当前团队内人数超出该套餐团队人数上限，请联系管理员管理团队人数或更换其他套餐。
            </template>
          </div>

          <Pay
            v-else
            :key="refreshPayComponentKey"
            :skuId="activeSkuId"
            :tradeNo="props.defaultActiveSkuTradeNo"
            :isActiveVipTab="activeTab === SKU_TYPE.VIP"
            :first="activeSku?.first"
            @success="handlePaySuccess"
          />
        </div>
      </div>
    </div>
    <Ad :class="$style.Ad" />
  </Modal>
</template>

<script lang="ts" setup>
  import { watch, computed, ref } from 'vue';
  import { SwiperList } from '@lingtu/components';
  import { Modal, SkeletonButton, Button } from 'ant-design-vue';
  import Header from '../components/header.vue';
  import Sku from '../components/sku.vue';
  import Pay from '../components/pay.vue';
  import Customer from '../components/customer.vue';
  import SelectPeople from '../components/select-people.vue';
  import Tab from '../components/tab/index.vue';
  import Introduction from '../components/introduction/index.vue';
  import { GetSkusRes } from '../apis/entities';
  import { usePayment } from './hooks/usePayment';
  import { SKU_TYPE } from '../constants';
  import { useTab } from './hooks/useTab';
  import Ad from '../components/ad.vue';

  const props = defineProps({
    visible: {
      type: Boolean,
      default: false,
    },

    getUserInfo: {
      type: Function,
      default: null,
    },

    getOrgInfo: {
      type: Function,
      default: null,
    },

    getLingdouInfo: {
      type: Function,
      default: null,
    },

    onPaySuccess: {
      type: Function,
      default: null,
    },

    onPayCancel: {
      type: Function,
      default: null,
    },

    onGoMemberPage: {
      type: Function,
      default: null,
    },

    defaultActiveSkuId: {
      type: Number,
      default: null,
    },

    // 还原待支付订单需要用到
    defaultActiveSkuTradeNo: {
      type: String,
      default: null,
    },

    onlyShowActiveSku: {
      type: Boolean,
      default: false,
    },

    // 只展示灵豆包
    onlyLingdou: {
      type: Boolean,
      default: false,
    },

    // 切换至某个tab下
    defaultActiveTab: {
      type: String,
      default: null,
    },

    zIndex: {
      type: Number,
      default: 2000,
    },
  });

  const emits = defineEmits(['update:visible']);
  const selectPeople = ref('5');

  const {
    skus,
    skuLoading,
    skuError,
    orgInfo,
    lingdouInfo,
    activeSkuId,
    activeSku,
    init,
    handleActiveSku,
    isPersonal,
    refreshPayComponentKey,
    isAdmin,
    isVip,
  } = usePayment({
    getUserInfo: props.getUserInfo,
    getOrgInfo: props.getOrgInfo,
    getLingdouInfo: props.getLingdouInfo,
  });

  const { activeTab, tabs, handleActiveTab } = useTab(isPersonal);

  const tabsList = computed(() => {
    return tabs.value
      .filter((tab) => {
        if (props.onlyLingdou) {
          return tab.value === SKU_TYPE.PURCHASE;
        }
        return true;
      })
      .map((tab) => {
        if (tab.value === SKU_TYPE.VIP) {
          return {
            ...tab,
            first: !!skus.value.find((v: GetSkusRes) => v.type === SKU_TYPE.VIP && v.first),
          };
        } else {
          return {
            ...tab,
            first: !!skus.value.find((v: GetSkusRes) => v.type === SKU_TYPE.PURCHASE && v.first),
          };
        }
      });
  });

  const skusList = computed(() => {
    // 只展示当前选中的sku
    if (props.onlyShowActiveSku) {
      return skus.value.filter((v: GetSkusRes) => v.skuId === activeSkuId.value);
    }

    // 展示vip商品
    if (activeTab.value === SKU_TYPE.VIP) {
      return skus.value.filter(
        (v: GetSkusRes) =>
          v.type === SKU_TYPE.VIP && (isPersonal.value ? true : v.seat === selectPeople.value),
      );
    }

    // 展示单购商品
    if (activeTab.value === SKU_TYPE.PURCHASE) {
      return skus.value.filter((v: GetSkusRes) => v.type === SKU_TYPE.PURCHASE);
    }

    return [];
  });

  watch(
    () => props.visible,
    async (v) => {
      if (v) {
        await init();

        // 如果有默认选中的sku，则切换对应tab下
        if (props.defaultActiveSkuId) {
          const sku = skus.value.find((v) => v.skuId === props.defaultActiveSkuId);
          if (sku) {
            handleActiveSku(props.defaultActiveSkuId);
            activeTab.value = sku.type;
            selectPeople.value = sku.seat;
          }
        } else {
          if (orgInfo.value.memberCount > 20) {
            selectPeople.value = '';
          } else {
            const breakPoint = [5, 10, 20];
            for (let i = 0; i < breakPoint.length; i++) {
              if (orgInfo.value.memberCount <= breakPoint[i]) {
                selectPeople.value = breakPoint[i] + '';
                break;
              }
            }
          }

          if (props.onlyLingdou) {
            handleUpdateTab(SKU_TYPE.PURCHASE);
          } else {
            // 有默认选中的tab，切换并激活当前tab下第一个sku
            if (props.defaultActiveTab) {
              handleUpdateTab(props.defaultActiveTab);
            }
            // 选中
            else {
              handleUpdateTab(SKU_TYPE.VIP);
            }
          }
        }
      }
    },
    {
      immediate: true,
    },
  );

  // 选择团队人数
  function handleUpdateSelectPeople(v) {
    selectPeople.value = v;

    if (skusList.value[0]) {
      // 默认激活第一个sku
      handleActiveSku(skusList.value[0].skuId);
    }
  }

  // 切换tab
  function handleUpdateTab(v: SKU_TYPE) {
    handleActiveTab(v);

    // 默认激活第一个sku
    if (skusList.value[0]) {
      handleActiveSku(skusList.value[0].skuId);
    }
  }

  // 支付成功
  function handlePaySuccess(result) {
    close();
    props?.onPaySuccess(result);
  }

  function close() {
    props?.onPayCancel();
    emits('update:visible', false);
  }
</script>

<style lang="less" module>
  .Modal {
    padding: 0;

    :global {
      .ant-modal {
        padding-bottom: 130px !important;
      }

      .ant-modal-body {
        padding: 0;
        border-radius: 6px;
        overflow: hidden;
      }

      .ant-modal-content {
        border-radius: 16px;
      }
    }
  }

  .SkeletonButton {
    margin-right: 24px;
    width: 180px !important;
    height: 190px;
    display: block !important;

    > span {
      width: 100% !important;
      height: 100% !important;
    }
  }

  .Container {
    display: flex;
  }

  .Content {
    padding: 24px;
    flex: 1;
    min-height: 606px;
  }

  .Tip {
    display: flex;
    justify-content: space-between;

    > div {
      color: rgba(255, 255, 255, 0.85);
      font-size: 14px;
      font-weight: 400;
      line-height: 22px;

      > span {
        font-size: 14px;
        font-weight: 400;
        line-height: 22px;
        color: rgba(209, 108, 68, 1);
      }
    }

    > a {
      font-size: 12px;
      font-weight: 400;
      line-height: 20px;
      color: rgba(255, 255, 255, 0.85) !important;

      &:hover {
        color: rgba(209, 108, 68, 1) !important;
      }
    }
  }

  .PayBlock {
    display: flex;
    justify-content: space-between;
    align-items: center;
    background-color: rgba(40, 40, 40, 1);
    padding: 16px;
    border-radius: 16px;
  }

  .SkuLoading {
    display: flex;
    align-items: center;
  }

  .SkuError {
    display: flex;
    align-items: center;
    justify-content: center;
    height: 252px;
  }

  .MemberTip {
    font-size: 14px;
    font-weight: 400;
    line-height: 22px;
    color: rgba(255, 255, 255, 0.85);

    > div {
      text-align: center;
      margin-top: 8px;

      button {
        width: 96px;
        height: 40px;
      }
    }
  }

  .Ad {
    position: absolute;
    bottom: -132px;
    left: 50%;
    transform: translate(-50%);
  }
</style>
